<div class="about">
  <div class="header">
    <app-button btnType="icon" (onChangeClick)="closeRightMenu()">
      <app-icon>close</app-icon>
    </app-button>
    <span>{{ 'about_chat' | translate }}</span>

    <div class="flex-fill"></div>

    @if (!chatService.isLoaderAbout) {
      <app-button (onChangeClick)="onChangeTitleChat()" [btnType]="'icon'">
        <app-icon>edit</app-icon>
      </app-button>
    }
  </div>

  @if (chatService.isLoaderAbout) {
    <div class="box-loader">
      <app-loader />
    </div>
  }

  @if (chat && chat.id && !chatService.isLoaderAbout) {
    <div [ngClass]="{ 'hidden-scroll': baseService.isMobile }" class="crm-scroll additional-info">
      <div class="user info-block">
        <app-avatar
          size="100px"
          [title]="chat.title"
          [isBlocked]="chat.is_blocked"
          [mediaId]="$safeNavigationMigration(chat.x_data?.photo_id)"
          [chatId]="chat.id"
          [url]="chat.logo_url"
          [isGroup]="chat.sub_type === CHAT_SUB_TYPES.GROUP"
          [additionalUrl]="entityIcons[chat.external_type]"
          [additionalClass]="'big-icon'"
        />

        <span class="user-title-wrapper">
          <span class="user-title">
            {{ chat.title }}
          </span>
          <span class="user-clip badge text-truncate">{{ chat.channel_name }}</span>
        </span>
      </div>

      @if ((chatService.aboutActions && Object.keys(chatService.aboutActions).length) || chat) {
        <div class="settings info-block">
          <label matRipple class="settings-item click-css" (click)="toggleTagsPicker($event)">
            <app-icon>sell</app-icon>
            <div class="settings-title-wrapper">
              <div class="settings-text">
                <span class="text-truncate">{{ 'chat_tags' | translate }}</span>
              </div>
              <app-icon class="!text-[var(--text-color-muted)]">{{
                isTagsPickerOpen ? 'expand_less' : 'expand_more'
              }}</app-icon>
            </div>
          </label>
          @if (isTagsPickerOpen) {
            <div
              class="overflow-hidden rounded-lg border border-slate-200 bg-slate-50"
              (click)="$event.stopPropagation()"
            >
              @if (!tags.length) {
                <span class="block p-3 text-center text-sm text-slate-500">{{ 'no_tags' | translate }}</span>
              } @else {
                <div class="sticky top-0 z-10 w-full border-b border-slate-200 bg-slate-50 p-2">
                  <div
                    class="flex h-10 w-full items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 text-slate-500 shadow-sm"
                  >
                    <span class="flex h-5 w-5 shrink-0 items-center justify-center" aria-hidden="true">
                      <app-icon [isFlexBox]="false" class="!text-[20px] !leading-5">search</app-icon>
                    </span>
                    <input
                      class="block h-full min-w-0 flex-1 border-0 bg-transparent text-base text-slate-800 outline-none placeholder:text-slate-400"
                      [(ngModel)]="tagSearchTerm"
                      [placeholder]="'search' | translate"
                      [attr.aria-label]="'search' | translate"
                    />
                  </div>
                </div>
                <div class="crm-scroll max-h-60 overflow-y-auto p-1">
                  @if (!filteredTags.length) {
                    <span class="block p-3 text-center text-sm text-slate-500">{{ 'nothing_found' | translate }}</span>
                  } @else {
                    @for (tag of filteredTags; track tag.id) {
                      <button
                        type="button"
                        class="flex min-h-10 w-full items-center gap-2.5 rounded-md px-2.5 text-left text-slate-800 transition-colors hover:bg-slate-200"
                        (click)="toggleChatTag(tag.id, $event)"
                      >
                        <span class="h-3 w-3 shrink-0 rounded-full" [style.background-color]="tag.color"></span>
                        <span class="min-w-0 flex-1 truncate">{{ tag.name }}</span>
                        @if (isTagUpdating(tag.id)) {
                          <span class="flex h-5 w-5 shrink-0 items-center justify-center"
                            ><app-loader size="tiny" strokeWidth="3"
                          /></span>
                        } @else if (isTagAssigned(tag.id)) {
                          <app-icon class="!h-5 !w-5 !min-w-5 !text-[20px] !leading-5">check</app-icon>
                        }
                      </button>
                    }
                  }
                </div>
              }
            </div>
          }
          <label matRipple class="settings-item click-css" (click)="toggleManagersPicker($event)">
            <app-icon>person</app-icon>
            <div class="settings-title-wrapper">
              <div class="settings-text">
                <span class="text-truncate">{{ 'manager' | translate }}</span>
                <span class="settings-description text-truncate">{{
                  chat.assigned_user?.name || ('not_assigned' | translate)
                }}</span>
              </div>
              <app-icon class="!text-[var(--text-color-muted)]">{{
                isManagersPickerOpen ? 'expand_less' : 'expand_more'
              }}</app-icon>
            </div>
          </label>
          @if (isManagersPickerOpen) {
            <div
              class="overflow-hidden rounded-lg border border-slate-200 bg-slate-50"
              (click)="$event.stopPropagation()"
            >
              <div class="sticky top-0 z-10 w-full border-b border-slate-200 bg-slate-50 p-2">
                <div
                  class="flex h-10 w-full items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 text-slate-500 shadow-sm"
                >
                  <span class="flex h-5 w-5 shrink-0 items-center justify-center" aria-hidden="true">
                    <app-icon [isFlexBox]="false" class="!text-[20px] !leading-5">search</app-icon>
                  </span>
                  <input
                    class="block h-full min-w-0 flex-1 border-0 bg-transparent text-base text-slate-800 outline-none placeholder:text-slate-400"
                    [(ngModel)]="managerSearchTerm"
                    [placeholder]="'search' | translate"
                    [attr.aria-label]="'search' | translate"
                  />
                </div>
              </div>
              <div class="crm-scroll max-h-60 overflow-y-auto p-1">
                @if (!managerSearchTerm.trim()) {
                  <button
                    type="button"
                    class="flex min-h-10 w-full items-center gap-2.5 rounded-md px-2.5 text-left text-slate-500 transition-colors hover:bg-slate-200"
                    (click)="changeChatManager(null, $event)"
                  >
                    <app-icon class="!h-6 !w-6 !min-w-6 !text-[24px] !leading-6">person_off</app-icon>
                    <span class="min-w-0 flex-1 truncate">{{ 'not_assigned' | translate }}</span>
                    @if (updatingManagerId === null) {
                      <span class="flex h-5 w-5 shrink-0 items-center justify-center"
                        ><app-loader size="tiny" strokeWidth="3"
                      /></span>
                    } @else if (isManagerAssigned(null)) {
                      <app-icon class="!h-5 !w-5 !min-w-5 !text-[20px] !leading-5">check</app-icon>
                    }
                  </button>
                }
                @if (!filteredManagers.length) {
                  <span class="block p-3 text-center text-sm text-slate-500">{{ 'nothing_found' | translate }}</span>
                } @else {
                  @for (manager of filteredManagers; track manager.id) {
                    <button
                      type="button"
                      class="flex min-h-10 w-full items-center gap-2.5 rounded-md px-2.5 text-left text-slate-800 transition-colors hover:bg-slate-200"
                      (click)="changeChatManager(manager.id, $event)"
                    >
                      <app-avatar
                        size="24px"
                        [title]="manager.name"
                        [url]="manager.avatar_url"
                        [isPhotoGallery]="false"
                      />
                      <span class="min-w-0 flex-1 truncate">{{ manager.name }}</span>
                      @if (updatingManagerId === manager.id) {
                        <span class="flex h-5 w-5 shrink-0 items-center justify-center"
                          ><app-loader size="tiny" strokeWidth="3"
                        /></span>
                      } @else if (isManagerAssigned(manager.id)) {
                        <app-icon class="!h-5 !w-5 !min-w-5 !text-[20px] !leading-5">check</app-icon>
                      }
                    </button>
                  }
                }
              </div>
            </div>
          }
          <label matRipple (click)="openHistory()" class="settings-item click-css">
            <app-icon>history</app-icon>
            <div class="settings-title-wrapper">
              <div class="settings-text">
                <span class="text-truncate">{{ 'board_v3_tab_timeline_history' | translate }}</span>
              </div>
            </div>
          </label>
          @for (item of chatService.aboutActions; track $index) {
            <label
              matRipple
              (click)="item.tool === TOOLS.BUTTON || TOOLS.PROFILE ? item.action(item) : null"
              class="settings-item click-css"
            >
              @if (item.is_svg) {
                <app-icon [svgIcon]="item.icon" />
              } @else {
                <app-icon>{{ item.icon }}</app-icon>
              }

              <div class="settings-title-wrapper">
                <div class="settings-text">
                  <span class="text-truncate">{{ item.title | translate }}</span>
                  @if (item.description) {
                    <span class="settings-description text-truncate">{{ item.description }}</span>
                  }
                </div>

                @if (item.copyValue || item.tool === TOOLS.TOGGLE) {
                  <div class="settings-controls">
                    @if (item.copyValue) {
                      <app-button btnType="icon" (onChangeClick)="copyActionValue($event, item.copyValue)">
                        <app-icon>content_copy</app-icon>
                      </app-button>
                    }
                    @if (item.tool === TOOLS.TOGGLE) {
                      <app-toggle [(ngModel)]="item.value" [id]="item.key" (change)="item.action(item)" />
                    }
                  </div>
                }
              </div>
            </label>
          }
        </div>
      }

      @if (chatService.advert) {
        <chat-advert-info [advert]="chatService.advert" />
      }

      @if (chatService.deals) {
        <div class="deals info-block">
          @for (deal of chatService.deals; track $index) {
            <div
              matRipple
              class="deal-box click-css"
              (click)="openDeal(deal)"
              [ngStyle]="{ '--column-bg-color': deal.column.bg_color, '--column-text-color': deal.column.text_color }"
            >
              <div class="title-box">
                <span class="text-truncate">{{ deal.name }}</span>
                <span class="column-box text-truncate">{{ deal.column.name }}</span>
              </div>
              <div class="price">
                {{ parseCurrencyXXX(deal.price || 0, deal.currency) }}
              </div>
            </div>
          }
        </div>
      }

      @if (!hasLinkedDeals) {
        <div class="settings info-block">
          <label
            matRipple
            (click)="createLeadCard()"
            class="settings-item click-css"
            [ngClass]="{ 'pointer-events-none opacity-60': isCreatingLeadCard }"
          >
            @if (isCreatingLeadCard) {
              <span class="flex h-6 w-6 shrink-0 items-center justify-center">
                <app-loader size="tiny" strokeWidth="3" />
              </span>
            } @else {
              <app-icon>add</app-icon>
            }

            <div class="settings-title-wrapper">
              <div class="settings-text">
                <span class="text-truncate">{{ 'create' | translate }} {{ 'lead' | translate }}</span>
              </div>
            </div>
          </label>
        </div>
      }
    </div>
  }
</div>
